import React, { useState } from "react";
import CreatorTable, { formatNumber, scoreColor } from "./CreatorTable";
import CreatorDetails from "./CreatorDetails";
import "./MetricDrawer.css";

export default function MetricDrawer({ creators, onClose }) {
  const pageSize = 5;
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCreator, setSelectedCreator] = useState(null);

  if (!creators || creators.length === 0) return null;

  const totalPages = Math.ceil(creators.length / pageSize);
  const paginated = creators.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  return (
    <div className="metric-drawer">
      <div className="drawer-header">
        {!selectedCreator ? (
          <h3>Creators ({creators.length})</h3>
        ) : (
          <div className="breadcrumb">
            <button className="back-btn" onClick={() => setSelectedCreator(null)}>← Back</button>
            <h3>{selectedCreator.creator_name}</h3>
          </div>
        )}
        <button className="close-btn" onClick={onClose}>✕</button>
      </div>

      {!selectedCreator ? (
        <>
          <div className="drawer-content">
            <CreatorTable
              data={paginated}
              onSelect={setSelectedCreator}
              columns={[
                { key: "creator_name", label: "Creator" },
                { key: "niche", label: "Niche", render: val => <span className="badge">{val || "-"}</span> },
                { key: "followers", label: "Followers", render: val => formatNumber(val) },
                { key: "avg_views", label: "Avg Views", render: val => formatNumber(val) },
                { key: "score", label: "Score", render: val => (
                    <span className={`scoreBadge ${scoreColor(val)}`}>{val || 0}</span>
                  ) },
                { key: "platform", label: "Platform" }
              ]}
            />
          </div>

          <div className="pagination">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)}>Prev</button>
            <span>Page {currentPage} of {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)}>Next</button>
          </div>
        </>
      ) : (
        <CreatorDetails
          creator={selectedCreator}
          onClose={() => setSelectedCreator(null)}
          onEdit={() => {}}
          onDelete={() => {}}
        />
      )}
    </div>
  );
}
